import React, {useEffect, useState} from "react";
import {injectIntl} from "react-intl";
import moment from "moment";
import axios from 'axios'
import { withStyles } from "@material-ui/core/styles";
import { Box, IconButton, InputBase, List, Paper, Typography } from "@material-ui/core"
import { Clear, Search } from '@material-ui/icons'

import RideInfoCard from "./RideInfoCard";
import SkeletonTab from "./SkeletonTab";
import styles from './styles'
import useGlobalContext from "../../../common/hooks/useGlobalContext";
import messages from "./messages";

const LIVE_TRIPS = 'liveTrips'
const SCHEDULED_TRIPS = 'scheduledTrips'
const PAST_TRIPS = 'pastTrips'

const searchDelay = 2000

const RideInfoTab = props => {
  const { classes, fetchTrips, info, intl: {formatMessage}, tabType } = props
  const {
    state: {
      activeBusinessId,
      activeServiceId,
      loading,
    },
    setLoading,
  } = useGlobalContext()
  const [searchDelayId, setSearchDelayId] = useState()
  const [filteredRides, setFilteredRides] = useState(info)
  const [searchValue, setSearchValue] = useState('')
  const [searching, setSearching] = useState(false)

  useEffect(() => {
    setFilteredRides(info)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [info.length])

  const rideRequests = async renderShimmer => {
    if (renderShimmer) setLoading(true);
    await fetchTrips();
    if (renderShimmer) setLoading(false);
  };

  useEffect(() => {
    let intervalId
    if (activeBusinessId && activeServiceId) {
      rideRequests(true);
      intervalId = setInterval(() => rideRequests(false), 10000)
    }
    return () => clearInterval(intervalId)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeServiceId, activeBusinessId, fetchTrips]);

  const fetchSpecifiedRide = async search => {
    let params = {
      business_entity_ids: activeBusinessId,
      ordering: '-created_at',
      service_id: activeServiceId,
      search,
      timestamp: moment().unix(),
    }

    setLoading(true)
    switch (tabType) {
      case LIVE_TRIPS:
        params.expand = 'driver.vehicle'
        await axios.get('/api/v2/livetrips', { params })
          .then(({ data }) => {
            setFilteredRides(data)
            setSearching(false)
          })
        break
      case SCHEDULED_TRIPS:
        params.ordering = 'scheduled_for_pickup_at'
        await axios.get('/api/v2/scheduledtriprequests', { params })
          .then(({ data }) => {
            setFilteredRides(data.results)
            setSearching(false)
          })
        break
      case PAST_TRIPS:
        params.all_trips = true
        params.expand = 'driver.vehicle'
        await axios.get('/api/v2/trips', { params })
          .then(({ data }) => {
            const onlyPastRides = data.filter(ride => ride.is_completed)
            setFilteredRides(onlyPastRides)
            setSearching(false)
          })
        break
      default:
        break
    }
    setLoading(false)
  }

  useEffect(() => {
    setSearchValue('')
  }, [tabType])

  const searchRides = e => {
    const search = (e && e.target) ? e.target.value : ''
    setSearchValue(search)
    clearTimeout(searchDelayId)
    if (search) {
      setSearchDelayId(setTimeout(() => {
        setSearching(true)
        fetchSpecifiedRide(search)
      } , searchDelay))
    }
  }

  const clearRides = () => {
    setSearchValue('')
    setSearching(false)
    setFilteredRides(info)
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => clearRides, [])

  const rides = searchValue && !searching ? filteredRides : info

  const rideContent = rides.length > 0
    ? (
    <React.Fragment>
      <List>
        {rides.map(ride => <RideInfoCard key={ride.id} rideInfo={ride}/>)}
      </List>
    </React.Fragment>
  ) : (
    <Box className={classes.centeredMessage}>
      <Typography>{formatMessage(messages.noRidesFound)}</Typography>
    </Box>
  )

  return (
    <React.Fragment>
      <Paper className={classes.search} square>
        <IconButton disabled>
          <Search />
        </IconButton>
        <InputBase className={classes.searchBar} disabled={loading} onChange={searchRides} placeholder="Search" value={searchValue}/>
        <IconButton disabled={loading} onClick={clearRides}>
          <Clear />
        </IconButton>
      </Paper>
      <Box className={classes.contentScroll}>
        {loading ? <SkeletonTab /> : rideContent}
      </Box>
    </React.Fragment>
  )
}

export default withStyles(styles)(injectIntl(RideInfoTab))
